// src/pdf/hojaDiariaPDF.js

import { createPdfEngine } from "./pdfEngine";

const formatFechaTituloMX = (fechaKey) => {
  if (!fechaKey) return "";

  try {
    const [year, month, day] = String(fechaKey).split("-");
    const fechaLocal = new Date(Number(year), Number(month) - 1, Number(day));

    return fechaLocal.toLocaleDateString("es-MX", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
  } catch {
    return fechaKey;
  }
};



const getDateKeyMX = (fecha) => {
  if (!fecha) return "";

  try {
    const d = new Date(fecha);
    if (Number.isNaN(d.getTime())) return "";

    const mx = new Date(
      d.toLocaleString("en-US", { timeZone: "America/Mexico_City" })
    );

    const year = mx.getFullYear();
    const month = String(mx.getMonth() + 1).padStart(2, "0");
    const day = String(mx.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};

const getIdExpediente = (id) => {
  if (!id) return "";
  return String(id).slice(-5).toUpperCase();
};

const getNombrePaciente = (paciente = {}) =>
  [
    paciente.nombre,
    paciente.apellido_paterno,
    paciente.apellido_materno,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

const calcularEdad = (fechaNacimiento) => {
  if (!fechaNacimiento) return "";

  const hoy = new Date();
  const nacimiento = new Date(fechaNacimiento);

  if (Number.isNaN(nacimiento.getTime())) return "";

  let edad = hoy.getFullYear() - nacimiento.getFullYear();
  const mes = hoy.getMonth() - nacimiento.getMonth();

  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
    edad--;
  }

  return edad >= 0 ? `${edad} años` : "";
};

const estaEnRango = (fechaKey, inicio, fin) => {
  if (!fechaKey || !inicio || !fin) return false;
  return fechaKey >= inicio && fechaKey <= fin;
};

export function generarHojaDiariaPDF({
  pacientes = [],
  fechaInicio,
  fechaFin,
  medico = {},
} = {}) {
  const filas = [];

  pacientes.forEach((paciente) => {
    const historia = paciente?.historia || null;
    const consultas = Array.isArray(paciente?.consultas)
      ? paciente.consultas
      : [];

    // ===============================
    // Historia clínica inicial
    // ===============================
    const fechaHistoria =
      historia?.fechaConsulta ||
      historia?.fecha_consulta ||
      historia?.creado_en ||
      historia?.fecha_creacion;

    if (fechaHistoria) {
      const fechaKey = getDateKeyMX(fechaHistoria);

      if (estaEnRango(fechaKey, fechaInicio, fechaFin)) {
        filas.push({
          fechaKey,
          fechaOrden: new Date(fechaHistoria).getTime(),
          idExpediente: getIdExpediente(paciente?.id),
          paciente: getNombrePaciente(paciente),
          edad: calcularEdad(paciente?.fecha_nacimiento),
          sexo: paciente?.sexo || "",
          
        });
      }
    }

    // ===============================
    // Consultas de seguimiento
    // ===============================
    consultas.forEach((consulta) => {
      const fechaConsulta =
        consulta?.fechaConsulta ||
        consulta?.fecha_consulta ||
        consulta?.creado_en ||
        consulta?.fecha_creacion;

      if (!fechaConsulta) return;

      const fechaKey = getDateKeyMX(fechaConsulta);

      if (estaEnRango(fechaKey, fechaInicio, fechaFin)) {
        filas.push({
          fechaKey,
          fechaOrden: new Date(fechaConsulta).getTime(),
          idExpediente: getIdExpediente(paciente?.id),
          paciente: getNombrePaciente(paciente),
          edad: calcularEdad(paciente?.fecha_nacimiento),
          sexo: paciente?.sexo || "",
          
        });
      }
    });
  });

  filas.sort((a, b) => {
  if (a.fechaKey !== b.fechaKey) return a.fechaKey.localeCompare(b.fechaKey);
  return (a.fechaOrden || 0) - (b.fechaOrden || 0);
});

  const porDia = filas.reduce((acc, fila) => {
    if (!acc[fila.fechaKey]) acc[fila.fechaKey] = [];
    acc[fila.fechaKey].push(fila);
    return acc;
  }, {});

  const engine = createPdfEngine({
  medico,
  paciente: {},
  logoDoctorBase64: null,
  tipoDocumento: "hojaDiaria",
});

  engine.writeCenteredTitle("HOJA DIARIA DE CONSULTA EXTERNA");
  engine.addVerticalSpace(4);

  const fechas = Object.keys(porDia);

  if (fechas.length === 0) {
    engine.writeParagraph("No hay consultas registradas en las fechas seleccionadas.");
    engine.save("hoja_diaria_consulta_externa.pdf");
    return;
  }

  fechas.forEach((fechaKey, index) => {
    if (index > 0) {
      engine.startNewPage();
    }

    engine.writeTitle(formatFechaTituloMX(fechaKey));

  engine.drawSimpleTable({
 columns: [
  "No.",
  "ID Expediente",
  "Paciente",
  "Edad",
  "Sexo",
],
rows: porDia[fechaKey].map((fila, idx) => [
  idx + 1,
  fila.idExpediente,
  fila.paciente,
  fila.edad,
  fila.sexo,
]),
colWidths: [10, 34, 84, 24, 18],
});

    engine.addVerticalSpace(3);
  });

  engine.save("hoja_diaria_consulta_externa.pdf");
}